export default "__VITE_ASSET__6bc512ff__"